export default __webpack_public_path__ + "static/media/Digital-Ready-Infrastructure.4fac6efc.pdf";